import { Check, X } from "lucide-react";
import type { EvalCheck } from "@/services/adminModelCurrency";
import { formatCheck } from "./helpers";

/** Compact pass/fail chips for the checks from an automatic test. */
const EvalChecks = ({ checks }: { checks: EvalCheck[] }) => {
  if (checks.length === 0) return null;
  return (
    <ul className="flex flex-wrap gap-1.5 text-xs">
      {checks.map(check => (
        <li
          key={check.name}
          className="inline-flex items-center gap-1 rounded-md border bg-muted/40 px-2 py-0.5"
        >
          {check.passed ? (
            <Check className="h-3.5 w-3.5 text-emerald-600" aria-label="Passed" />
          ) : (
            <X className="h-3.5 w-3.5 text-destructive" aria-label="Failed" />
          )}
          <span>
            {check.name}:{" "}
            <span className="tabular-nums text-muted-foreground">{formatCheck(check)}</span>
          </span>
        </li>
      ))}
    </ul>
  );
};

export default EvalChecks;
